import { FC } from 'react';

type DateCalendarIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const DateCalendarIcon: FC<DateCalendarIconProps> = ({ width = 24, height = 24, ...rest }) => (
  <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 2V6M8 2V6" stroke="#394B6F" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22" stroke="#394B6F" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 10H21" stroke="#394B6F" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.2671 18.7011L17 18V16.2668M21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 15.7909 14.7909 14 17 14C19.2091 14 21 15.7909 21 18Z" stroke="#394B6F" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
